export default __webpack_public_path__ + "static/media/ic_close_gray.58766c54.svg";